module.exports = __webpack_public_path__ + "img/tour-28.30003ce7.png";